/** Matches collapsed `MatterContactConnectionRichCard` with badges (e.g. matter Related Contacts). */
export const CONTACT_ROLE_SELECT_CARD_HEIGHT_CLASS = "h-[162px]";

/** Modal role pickers without badges (insurance, vehicles, lien, etc.). */
export const CONTACT_ROLE_SELECT_CARD_COMPACT_HEIGHT_CLASS = "h-[130px]";

const CONTACT_ROLE_SELECT_EMPTY_SHELL_BASE_CLASS =
  "border-border/70 bg-card relative box-border flex w-full min-w-0 shrink-0 flex-col overflow-hidden rounded-[28px] border px-3.5 py-2 shadow-sm";

/** Shared empty contact picker shell — keep in sync across pickers with badges. */
export const CONTACT_ROLE_SELECT_EMPTY_SHELL_CLASS = `${CONTACT_ROLE_SELECT_EMPTY_SHELL_BASE_CLASS} ${CONTACT_ROLE_SELECT_CARD_HEIGHT_CLASS}`;

/** Empty picker shell for modals without badge rows on the filled card. */
export const CONTACT_ROLE_SELECT_EMPTY_SHELL_COMPACT_CLASS = `${CONTACT_ROLE_SELECT_EMPTY_SHELL_BASE_CLASS} ${CONTACT_ROLE_SELECT_CARD_COMPACT_HEIGHT_CLASS}`;

export const CONTACT_ROLE_SELECT_EMPTY_BUTTON_CLASS =
  "hover:bg-muted/40 focus-visible:ring-ring absolute inset-0 z-[1] cursor-pointer rounded-[28px] border-0 bg-transparent p-0 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none";

/** Centered label/icon layer inside the shell (no inner dashed panel). */
export const CONTACT_ROLE_SELECT_EMPTY_BODY_CLASS =
  "relative z-0 flex h-full min-h-0 w-full flex-col items-center justify-center px-1 text-center";

/**
 * Body when secondary actions (e.g. assign client) sit below the main prompt.
 * Sits above {@link CONTACT_ROLE_SELECT_EMPTY_BUTTON_CLASS} so actions receive clicks;
 * `pointer-events-none` lets the top prompt still hit the overlay.
 */
export const CONTACT_ROLE_SELECT_EMPTY_BODY_WITH_ACTIONS_CLASS =
  "relative z-[2] pointer-events-none flex h-full min-h-0 w-full flex-col items-center justify-center px-1 text-center";

export const CONTACT_ROLE_SELECT_EMPTY_CONTENT_CLASS =
  "text-muted-foreground pointer-events-none flex flex-col items-center justify-center gap-1";

/** Secondary actions inside {@link CONTACT_ROLE_SELECT_EMPTY_BODY_WITH_ACTIONS_CLASS}. */
export const CONTACT_ROLE_SELECT_EMPTY_ACTION_CLASS =
  "pointer-events-auto relative";
